import { Pipe, PipeTransform } from '@angular/core';
import { AdminNewslettersService} from '../../admin/services/admin-newsletters.service';

@Pipe({
  name: 'alertLabel',
  pure: true,
  standalone: false
})
export class AlertLabelPipe implements PipeTransform {

  constructor(private newsletterService: AdminNewslettersService) {}

  transform(value: string, type: 'role' | 'zone' | 'level' | 'recurrence'): string {
    if (value === undefined || value === null) return '';

    if (type === 'recurrence' && (!value || value === 'none')) {
      return 'Ne pas répéter';
    }

    let list: any[] = [];

    switch (type) {
      case 'role':
        list = this.newsletterService.getRolesList();
        break;
      case 'zone':
        list = this.newsletterService.getZonesList();
        break;
      case 'level':
        list = this.newsletterService.getAlertLevels();
        break;
      case 'recurrence':
        list = this.newsletterService.getRecurrenceList();
        break;
      default:
        return value;
    }

    const found = list.find(item => item.value === value);
    return found ? found.name : value;
  }
}
